import PropTypes from "prop-types"
import React from "react"
import { Box } from "@material-ui/core"
import classNames from "classnames"
import CheckIcon from "@material-ui/icons/Check"

import useStyles from "./styles"

const StatusChecker = ({ role = {}, checkerSize = 25 }) => {
  const classes = useStyles()

  const locationArr = window.location.pathname.split("/")
  const page = locationArr[locationArr.length - 1].toLowerCase()

  return page === "deal-memo" || page === "estimate" ? (
    <Box
      className={classNames(classes.statusDot, {
        [classes.unassigned]: !role.first_name,
        [classes.rejected]: role.user_status === "rejected",
        [classes.unsent]:
          role.user_status === "unsent" ||
          role.user_status === undefined ||
          role.user_status === "error",
        [classes.sent]: role.user_status === "sent",
        [classes.accepted]:
          role.user_status === "available" ||
          role.user_status === "bill_requested" ||
          role.user_status === "bill_accepted" ||
          role.user_status === "approved",
      })}
      style={{
        width: checkerSize,
        height: checkerSize,
      }}
    >
      {(role.user_status === "available" ||
        role.user_status === "bill_requested" ||
        role.user_status === "bill_accepted" ||
        role.user_status === "approved") && (
        <CheckIcon className={classes.checkIcon} style={{ fontSize: 40 }} />
      )}
    </Box>
  ) : (
    <Box
      className={classNames(classes.statusDot, {
        [classes.unassigned]: !role.first_name,
        [classes.rejected]: role.user_status === "rejected",
        [classes.unsent]:
          (role.user_status !== "bill_requested" &&
            role.user_status !== "bill_accepted" &&
            role.user_status !== "approved") ||
          role.user_status === "error",
        [classes.sent]: role.user_status === "bill_requested",
        [classes.available]: role.user_status === "bill_accepted",
        [classes.accepted]: role.user_status === "approved",
      })}
      style={{
        width: checkerSize,
        height: checkerSize,
      }}
    >
      {role.user_status === "approved" && (
        <CheckIcon className={classes.checkIcon} />
      )}
    </Box>
  )
}

StatusChecker.propTypes = {
  role: PropTypes.object,
  checkerSize: PropTypes.number,
}

export default StatusChecker
